import React from "react";

const SeoRoutesContext = React.createContext(null);

export default SeoRoutesContext;
